// import store from '../store'
import '../types'

const constructError = (err?:CustomErrorObject) => {
  const _err = err || {} as CustomErrorObject
  
  const code = _err.code || "unspecified"
  const message = _err.message || "An unspecified error occurred. Please try again."
  const status = _err.status || 500

  return {code, message, status}
}

export const error = {
  alert: (err?:CustomErrorObject) => {
    
    const _err = constructError(err)
    alert(_err.message)

    // store.dispatch('addAlert', {type: "error", payload: {error: {code, message, status}}})
  },

  new: (message?:string, code?:string, status?:number):CustomErrorObject => {
    const _code = code || "unspecified"
    const _message = message || "An unspecified error occurred. Please try again."
    const _status = status || 500

    return {code: _code, message: _message, status: _status}
  }
}

export default {
  install(Vue) {
    Vue.prototype.$error = error
  }
}
